"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
const react_1 = __importDefault(require("react"));
const TextField = ({ field, value, onChange, error, disabled }) => (react_1.default.createElement("div", { className: "field-group" },
    react_1.default.createElement("label", { className: "field-label" },
        field.label,
        field.required && react_1.default.createElement("span", { className: "required" }, "*")),
    field.tooltip && react_1.default.createElement("span", { className: "field-hint" }, field.tooltip),
    react_1.default.createElement("input", { type: field.type === 'number' ? 'number' : 'text', className: `field-input${error ? ' error' : ''}`, name: field.key, value: value || '', onChange: (e) => onChange(field.key, e.target.value), placeholder: field.tooltip || '', disabled: disabled }),
    error && react_1.default.createElement("div", { className: "field-error" }, error)));
exports.TextField = TextField;
